import { PropertyTypeEnum } from 'api/real-estate';
import * as Yup from 'yup';

export const BorrowerRealEstateFormFieldNames = {
  Area: 'area',
  RoomCount: 'roomCount',
  PropertyType: 'propertyType',
  AddressSearch: 'addressSearch',
  AddressLine2: 'line2',
  Address: 'address',
  AddressStreet: 'address.address',
  AddressPostalCode: 'address.postalCode',
  AddressCity: 'address.city',
  AddressCountry: 'address.country'
} as const;

export interface BorrowerRealEstateAddress {
  address: string;
  postalCode: string;
  city: string;
  country: string;
  googlePlaceId?: string;
  latitude?: number;
  longitude?: number;
}

export interface BorrowerRealEstateFormValues {
  area: number | '';
  roomCount: number | '';
  propertyType: PropertyTypeEnum | '';
  addressSearch: string;
  line2: string;
  address: BorrowerRealEstateAddress;
}

export const emptyBorrowerRealEstateForm: BorrowerRealEstateFormValues = {
  area: '',
  roomCount: '',
  propertyType: '',
  addressSearch: '',
  line2: '',
  address: {
    address: '',
    postalCode: '',
    city: '',
    country: ''
  }
};

const ADDRESS_REQUIRED = 'Sélectionnez une adresse dans les suggestions';

const addressStructSchema = Yup.object().shape({
  address: Yup.string().required(ADDRESS_REQUIRED),
  postalCode: Yup.string().required(ADDRESS_REQUIRED),
  city: Yup.string().required(ADDRESS_REQUIRED),
  country: Yup.string().required(ADDRESS_REQUIRED),
  googlePlaceId: Yup.string().nullable(),
  latitude: Yup.number().nullable(),
  longitude: Yup.number().nullable()
});

export const borrowerRealEstateValidationSchema = Yup.object().shape({
  area: Yup.number()
    .typeError('Doit être un nombre')
    .min(0.1, 'Minimum 0,1 m²')
    .max(10000, 'Maximum 10 000 m²')
    .notRequired(),
  roomCount: Yup.number()
    .typeError('Doit être un nombre')
    .integer('Doit être un entier')
    .min(1, 'Minimum 1 pièce')
    .max(50, 'Maximum 50 pièces')
    .notRequired(),
  propertyType: Yup.mixed<PropertyTypeEnum>()
    .oneOf([...Object.values(PropertyTypeEnum), ''] as any[])
    .notRequired(),
  addressSearch: Yup.string()
    .required('Ce champ est requis')
    .test(
      'google-place-selected',
      ADDRESS_REQUIRED,
      function () {
        const { address } = this.parent as BorrowerRealEstateFormValues;
        return Boolean(address && address.address && address.city && address.postalCode);
      }
    ),
  line2: Yup.string().max(200, 'Maximum 200 caractères').notRequired(),
  address: addressStructSchema
});
